// extracted by mini-css-extract-plugin
module.exports = {"typographyUnderline":"typography_typographyUnderline__1A1w1"};